import React from 'react';
import { useLandingLogic } from './hook/useLandingLogic';

/**
 * HOC to inject landing logic as props to the wrapped component.
 * Follows the HOC pattern as per architecture guide.
 */
export function withLandingLogic(WrappedComponent) {
  return function LandingLogicWrapper(props) {
    const logic = useLandingLogic();
    return <WrappedComponent {...logic} {...props} />;
  };
}
